<template>
    <div class="w100 bgWhite">
        <article class="wContent center" style="padding-top: 20px">
            <QuoteControl></QuoteControl>
        </article>
    </div>
</template>
<script>
import QuoteControl from '../../templates/quoteControl'
export default {
    name: 'AddQuote',
    components: { QuoteControl },
    data() {
        return {}
    },
    mounted () {},
    methods: {
        
    }
    
}
</script>

<style>

</style>